<template>
  <CustomPage title="活动关注">
    <div slot="content" style="height: 100%">
      <div class="p-3">
        <div
          class="flex flex-wrap justify-evenly text-center text-sm mb-3"
          style="height: 35px"
        >
          <div class="box-border w-1/4 flex justify-center">
            <div
              class="rounded-full font-light my-1 py-1"
              :class="{ active: status === '0' }"
              style="width: 6rem; background-color: #eeeeee"
              @click="status = '0'"
            >
              开始活动
            </div>
          </div>
          <div class="box-border w-1/4 flex justify-center">
            <div
              class="rounded-full font-light my-1 py-1"
              :class="{ active: status === '1' }"
              style="width: 6rem; background-color: #eeeeee"
              @click="status = '1'"
            >
              预告活动
            </div>
          </div>
          <div class="box-border w-1/4 flex justify-center">
            <div
              class="rounded-full font-light my-1 py-1"
              :class="{ active: status === '2' }"
              style="width: 6rem; background-color: #eeeeee"
              @click="status = '2'"
            >
              已过期
            </div>
          </div>
        </div>
        <ActivityList :status="status" />
      </div>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import ActivityList from "./components/ActivityList.vue";
export default {
  components: { CustomPage, ActivityList },
  data() {
    return {
      status: "0",
    };
  },
};
</script>
<style scoped>
.active {
  background-color: #d8283b !important;
  color: #fff;
}
</style>